<template>
  <transition name="slide-in">
    <strong v-if="displayInvalid" class="validation-message">
      {{ validationMessage }}
    </strong>
  </transition>
</template>

<script>
import BaseComponent from "../../../BaseComponent";

/**
 * @group Inputs - parts
 * The validation message that shows up under inputs when they are invalid.
 */
export default {
  name: "ValidationMessage",
  mixins: [BaseComponent],
  props: {
    // The message that is shown
    validationMessage: {
      required: true,
      type: String,
    },
    // When true, validation message is shown
    displayInvalid: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../style_variables/style_variables.scss";
.validation-message {
  @extend %caption_style;
  display: block;
  color: $red;
  padding-top: 4px;
  overflow: hidden;
}
.slide-in-enter-active,
.slide-in-leave-active {
  will-change: height, padding;
  transition: all 220ms;
}
.slide-in-enter,
.slide-in-leave-to {
  height: 0px;
  padding: 0px;
}
</style>
